import { configureEcho } from '@laravel/echo-react';

export function initWebsocket() {
  try {
    configureEcho({
      broadcaster: 'reverb',
      key: process.env.REACT_APP_WS_KEY || '',
      wsHost: process.env.REACT_APP_WS_HOST || '',
      wsPort: process.env.REACT_APP_WS_PORT || '',
      wssPort: process.env.REACT_APP_WS_PORT || '',
      forceTLS: true,
      namespace: '',
      enabledTransports: ['ws', 'wss'],
      channelAuthorization: {
        customHandler: async (payload: any, callback: any) => {
          const { socketId, channelName } = payload;
          const formData = new FormData();
          formData.append('socket_id', socketId);
          formData.append('channel_name', channelName);
          try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/v2/broadcasting/auth`, {
              method: 'POST',
              body: formData,
              credentials: 'include',
            });
            const data = await response.json();
            callback(null, data);
          } catch (error) {
            console.error('Pusher channel auth error:', error);
            callback(error, null);
          }
        },
      },
    });
  } catch (error) {
    console.log(error);
  }
}
